import React, { Suspense, useState, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Spin, Modal, Button } from 'antd';
import ContentPage from './ContentPage';
import routerArr from './routerArr';
import { getCurrentMenuApi } from 'api/menu';
import { postReadNoticeRecordApiV2 } from '../api/readNoticeRecord';
import RichText from 'components/RichText';
import { getUserNoticeByIdApiV2 } from 'api/userNotice';

const defaultIsLogin = !!sessionStorage.getItem('accessToken');
const userMenus = sessionStorage.getItem('menus');

const Container = () => {
    const [isLogin, setIsLogin] = useState(defaultIsLogin);
    const [menuLoading, setmenuLoading] = useState(true);
    const [msgVisible, setMsgVisible] = useState(false);
    const { usertype } = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    const [readStartTime, setReadStartTime] = useState(0);
    const richTextRef = useRef(null);

    useEffect(() => {
        if (userMenus) {
            getCurrentMenu();
        } else {
            setmenuLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserNotice = () => {
        getUserNoticeByIdApiV2({ id: 4 }).then(res => {
            if (res.success) {
                setMsgVisible(true);
                richTextRef.current && richTextRef.current.setHtml(res.content);
                setReadStartTime(new Date().getTime());
            }
        });
    };
    // 获取登录账号菜单
    const getCurrentMenu = () => {
        setmenuLoading(true);

        getCurrentMenuApi().then(res => {
            const menus = (res.menuDtoSet || []).map(menu => menu.code);
            if (res.success) {
                sessionStorage.setItem('menus', menus.join(','));
                setmenuLoading(false);
            }
        });
    };

    // 登录注销设置登录状态
    const loginSuccess = () => {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        // 登录成功 获取提示信息
        if (userInfo.usertype === 'user') {
            getUserNotice();
        }
        setIsLogin(true);
    };
    const logoutSuccess = () => {
        setIsLogin(false);
    };

    const readNotice = () => {
        setMsgVisible(false);
        const loginTime = parseInt(readStartTime / 1000);
        postReadNoticeRecordApiV2({
            remark: '电脑端',
            readStartTime: readStartTime,
            loginTime: loginTime,
        }).then(res => {
            console.log(res);
        });
    };

    return (
        <>
            {menuLoading ? (
                <Spin size="large">
                    <div style={{ height: '100vh', width: '100vw' }}></div>
                </Spin>
            ) : (
                <BrowserRouter>
                    <Suspense
                        fallback={
                            <Spin size="large">
                                <div style={{ height: '100vh', width: '100vw' }}></div>
                            </Spin>
                        }>
                        <Switch>
                            {routerArr().map(route => {
                                const {
                                    path,
                                    exact,
                                    routes,
                                    component: Component,
                                    notAuth,
                                    key,
                                } = route;
                                const newItem = { path, exact, routes };
                                return (
                                    <Route
                                        key={key}
                                        {...newItem}
                                        render={props => {
                                            // 无需登录及已登录展示组件
                                            return (notAuth || isLogin) && Component ? (
                                                !notAuth ? (
                                                    <ContentPage
                                                        logoutSuccess={logoutSuccess}
                                                        isLogin={isLogin}>
                                                        <Component
                                                            {...props}
                                                            loginSuccess={loginSuccess}
                                                            logoutSuccess={logoutSuccess}
                                                        />
                                                    </ContentPage>
                                                ) : (
                                                    <Component
                                                        {...props}
                                                        loginSuccess={loginSuccess}
                                                        logoutSuccess={logoutSuccess}
                                                    />
                                                )
                                            ) : (
                                                <Redirect to="/404" />
                                            );
                                        }}
                                    />
                                );
                            })}
                            <Route
                                path="/"
                                exact
                                render={() => (
                                    <Redirect
                                        to={usertype === 'admin' ? '/adminLogin' : '/login'}
                                    />
                                )}
                            />
                            <Redirect to="/404" />
                        </Switch>
                    </Suspense>
                </BrowserRouter>
            )}
            {/* 登录完成弹窗提示信息 */}
            <Modal
                centered
                visible={msgVisible}
                closable={false}
                maskClosable={false}
                width={1000}
                footer={null}>
                <div style={{ height: 'calc(100vh - 200px)' }}>
                    <RichText
                        defaultValue={'正在获取入住须知...'} // 初始值
                        disabled={true} // 是否禁用
                        ref={richTextRef}
                    />
                </div>
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                    <Button type="primary" onClick={readNotice}>
                        我已阅读
                    </Button>
                </div>
            </Modal>
        </>
    );
};
export default Container;
